import { GET_ALERTS_SUCCESS, GET_ALERTS_FAILURE, GET_ALERTS_REQUEST } from './alertsActionTypes';

export const getAlertsRequest = () => ({
  type: GET_ALERTS_REQUEST
});

export const getAlertsSuccess = (payload: any) => ({
  type: GET_ALERTS_SUCCESS,
  payload: payload
});

export const getAlertsFailure = (error: Error) => ({
  type: GET_ALERTS_FAILURE,
  payload: error
});
